'use strict';

jQuery(function ($) { // この中であればWordpressでも「$」が使用可能になる

  //ドロワーメニュー
  $("#MenuButton").click(function () {
    // $(".l-drawer-menu").toggleClass("is-show");
    // $(".p-drawer-menu").toggleClass("is-show");
    $(".js-drawer-open").toggleClass("open");
    $(".drawer-menu").toggleClass("open");
    $("html").toggleClass("is-fixed");

  });

  // スムーススクロール (絶対パスのリンク先が現在のページであった場合でも作動)

  $(document).on('click', 'a[href*="#"]', function () {
    let time = 400;
    let header = $('header').innerHeight();
    let target = $(this.hash);
    if (!target.length) return;
    let targetY = target.offset().top - header;
    $('html,body').animate({ scrollTop: targetY }, time, 'swing');
    return false;
  });

  var onKeyBoard = false;
  $('.locator__search').val("");
  $('.locator__search').on('keyup', function (e) {
    var $parent = $(this).parent();
    if (e.target.value && !onKeyBoard) {
        $parent.find('input[type="submit"]').addClass('hidden');
        $parent.find('.locator__search--close').removeClass('hidden');
        onKeyBoard = true;
    }
    if (!e.target.value) {
        $parent.find('input[type="submit"]').removeClass('hidden');
        $parent.find('.locator__search--close').addClass('hidden');
        onKeyBoard = false
    };
  });
  $('.locator__search--close').on('click', function () {
    $('.locator__search--close').addClass('hidden');
    $('.form__locator__search input[type="submit"]').removeClass('hidden');
    $(".locator__search").val("");
    onKeyBoard = false 
  });

});


$(document).ready(function () {
    var hash = window.location.hash;
    if (hash === '#area-search') {
        $('.location__link.detect-area').trigger('click');
    }
})

/**
 * appends params to a url
 * @param {string} url - Original url
 * @param {Object} params - Parameters to append
 * @returns {string} result url with appended parameters
 */
function appendToUrl(url, params) {
    var newUrl = url;
    newUrl += (newUrl.indexOf('?') !== -1 ? '&' : '?') + Object.keys(params).map(function (key) {
        return key + '=' + encodeURIComponent(params[key]);
    }).join('&');

    return newUrl;
}

/**
 * Uses google maps api to render a map
 */
function maps() {
    var ww = $(window).width();
    var map;
    var baseStoreDetailUrl = $('.map-canvas').data('store-detail-url')
    var mapdiv = JSON.parse($('.map-canvas').attr('data-locations'));
    var iconURL = $('.map-canvas').data('store-icon');
    var infowindow = new google.maps.InfoWindow();  
    var queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    
    // Init U.S. Map in the center of the viewport
    var latlng = (urlParams.get("lat") && urlParams.get("lng")) ? new google.maps.LatLng(urlParams.get("lat"), urlParams.get("lng")) : new google.maps.LatLng(mapdiv[0].latitude, mapdiv[0].longitude) ;
    var mapOptions = {
        zoom: 14,
        scrollwheel: false,
        streetViewControl:false,
        center: latlng,
        mapTypeControl:false,
        mapTypeControlOptions: { mapTypeIds: ['style', google.maps.MapTypeId.ROADMAP] }
    };

    map = new google.maps.Map($('.map-canvas')[0], mapOptions);
    var styleOptions = [
        {
            'stylers': [
                {
                    'gamma': 0.8
                },
                {
                'saturation': -100
                },
                {
                'lightness': 20
                }
            ]
         }
    ];
    var styledMapOptions = { name:  $('.map-canvas').data('store-name') || "TOMORROLAND"}
    var originalType = new google.maps.StyledMapType(styleOptions, styledMapOptions);
    map.mapTypes.set('style', originalType);
    map.setMapTypeId('style');

    var bounds = new google.maps.LatLngBounds();
    // STORE MARKER
    mapdiv.forEach(function (m) {
        var storeLocation = new google.maps.LatLng(m.latitude.toString(), m.longitude.toString() );
        const storeIcon = {
            url: iconURL,
            scaledSize: ww >= 768 ? new google.maps.Size(50, 50) : new google.maps.Size(40, 40), // scaled size
        };
        var marker = new google.maps.Marker({
            position: storeLocation,
            map: map,
            title: m.name,
            icon: storeIcon,
        });
        //TL_FOR_RUBY-4649での対応ために以下のコメントアウト
        // marker.addListener('click', function () {
        //     infowindow.setOptions({
        //         content: m.infoWindowHtml + `<p style="padding-top: 5px"><a style="text-decoration-line: underline; font-style: italic;" href="${baseStoreDetailUrl+'?id='+$(m.infoWindowHtml).data('store-id')}">View detail</a></p>`
        //     });
        //     infowindow.open(map, marker);
        // });

        // Create a minimum bound based on a set of storeLocations
        bounds.extend(marker.position);
    });
    //CURRENT MARKER
    if (urlParams.get("lat") && urlParams.get("lng")) {
        var currentLocation = new google.maps.LatLng(urlParams.get("lat"), urlParams.get("lng"));
        const pinIcon = {
            url: $('.map-canvas').data('point-icon'),
            scaledSize: ww >= 768 ? new google.maps.Size(50, 50) : new google.maps.Size(40, 40), // scaled size
        };
        var marker1 = new google.maps.Marker({
            position: currentLocation,
            map: map,
            icon: pinIcon,
        });
        // Create a minimum bound based on a set of storeLocations
        bounds.extend(marker1.position);
    }
    // // Fit the all the store marks in the center of a minimum bounds when any store has been found.
    // if (mapdiv && mapdiv.length !== 0) {
    //     map.fitBounds(bounds);
    // }
}

/**
 * Renders the results of the search and updates the map
 * @param {Object} data - Response from the server
 */
function updateStoresResults(data) {
    var $resultsDiv = $('.results');
    var $mapDiv = $('.map-canvas');
    var hasResults = data.stores.length > 0;

    if (!hasResults) {
        $('.store-locator-no-results').show();
    } else {
        $('.store-locator-no-results').hide();
    }

    $resultsDiv.empty()
        .data('has-results', hasResults)
        .data('radius', data.radius)
        .data('search-key', data.searchKey);

    $mapDiv.attr('data-locations', data.locations);

    if ($mapDiv.data('has-google-api')) {
        maps();
    } else {
        $('.store-locator-no-apiKey').show();
    }

    if (data.storesResultsHtml) {
        $resultsDiv.append(data.storesResultsHtml);
    }
}

/**
 * Search for stores with new zip code
 * @param {HTMLElement} element - the target html element
 * @returns {boolean} false to prevent default event
 */
function search(element) {
    var dialog = element.closest('.in-store-inventory-dialog');
    var spinner = dialog.length ? dialog.spinner() : $.spinner();
    spinner.start();
    var $form = element.closest('.store-locator');
    var radius = $('.results').data('radius');
    var url = $form.attr('action');
    var urlParams = { radius: radius };

    var payload = $form.is('form') ? $form.serialize() : { postalCode: $form.find('[name="postalCode"]').val() };

    url = appendToUrl(url, urlParams);

    $.ajax({
        url: url,
        type: $form.attr('method'),
        data: payload,
        dataType: 'json',
        success: function (data) {
            spinner.stop();
            updateStoresResults(data);
            $('.select-store').prop('disabled', true);
        }
    });
    return false;
}

module.exports = {
    init: function () {
        if ($('.map-canvas').data('has-google-api')) {
            maps();
        } else {
            $('.store-locator-no-apiKey').show();
        }

        if (!$('.results').data('has-results')) {
            $('.store-locator-no-results').show();
        }
    },

    search: function () {
        $('.store-locator-container form.store-locator').submit(function (e) {
            e.preventDefault();
            search($(this));
        });
        $('.store-locator-container .btn-storelocator-search[type="button"]').click(function (e) {
            e.preventDefault();
            search($(this));
        });
    },

    detectAreaLocation: function () {
        $(document).on('click', '.location__link.detect-area', function () {
            $('body, html').css('height', '100%').css('overflow', 'hidden');
            $('body').css('overflow', 'auto');
            var state = false;
	        var scrollpos;
            if(state == false) {
                scrollpos = $(window).scrollTop();
                $('body').addClass('fixed').css({'top': -scrollpos});
                state = true;
                $('#modalwrap').addClass('modal_area');
            }
        });
        $(document).on('click', '#modalwrap .prefecture__closed', function () {
            setTimeout(function () {
                $('body').removeClass('lock_scroll');
            }, 600)
            var state = false;
	        var scrollpos;
            if(state == false) {
                scrollpos = $(window).scrollTop();
                $('body').removeClass('fixed').css({'top': '0px'});
                state = true;
                $('#modalwrap').removeClass('modal_area');
            }
        })
    },

    changeRadius: function () {
        $('.store-locator-container .radius').change(function () {
            var radius = $(this).val();
            var searchKeys = $('.results').data('search-key');
            var url = $(this).data('action-url');
            var urlParams = {};

            if (searchKeys.postalCode) {
                urlParams = {
                    radius: radius,
                    postalCode: searchKeys.postalCode
                };
            } else if (searchKeys.lat && searchKeys.long) {
                urlParams = {
                    radius: radius,
                    lat: searchKeys.lat,
                    long: searchKeys.long
                };
            }

            url = appendToUrl(url, urlParams);
            var dialog = $(this).closest('.in-store-inventory-dialog');
            var spinner = dialog.length ? dialog.spinner() : $.spinner();
            spinner.start();
            $.ajax({
                url: url,
                type: 'get',
                dataType: 'json',
                success: function (data) {
                    spinner.stop();
                    updateStoresResults(data);
                    $('.select-store').prop('disabled', true);
                }
            });
        });
    },
    selectStore: function () {
        $('.store-locator-container').on('click', '.select-store', (function (e) {
            e.preventDefault();
            var selectedStore = $(':checked', '.results-card .results');
            var data = {
                storeID: selectedStore.val(),
                searchRadius: $('#radius').val(),
                searchPostalCode: $('.results').data('search-key').postalCode,
                storeDetailsHtml: selectedStore.siblings('label').find('.store-details').html(),
                event: e
            };

            $('body').trigger('store:selected', data);
        }));
    },
    updateSelectStoreButton: function () {
        $('body').on('change', '.select-store-input', (function () {
            $('.select-store').prop('disabled', false);
        }));
    }
};

